var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M15.5 14.5H8.5","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fill":"none","d":"M8.5 10.5H15.5","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"fill":"none","fillRule":"evenodd","clipRule":"evenodd","d":"M4.151 16.396C3.421 15.096 3 13.598 3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12C21 16.971 16.971 21 12 21C10.402 21 8.904 20.579 7.604 19.849L3 21L4.151 16.396Z","stroke":"currentColor","strokeWidth":"1.5882","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Chat.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Chat;

Chat.default = Chat;
